import styled from 'styled-components';

export const Section = styled.div<{ $disabled?: boolean }>`
  background: ${({ theme }) => theme.colors['neutral-0']};
  border: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  border-radius: 16px;
  padding: 32px;
  filter: drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.07));
  opacity: ${({ $disabled = false }) => ($disabled ? 0.6 : 1)};
  pointer-events: ${({ $disabled = false }) => ($disabled ? 'none' : 'unset')};
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 16px;
`;

export const Title = styled.h2`
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  color: ${({ theme }) => theme.colors['neutral-100']};
`;

export const JobLink = styled.a`
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: ${({ theme }) => theme.colors['primary-60']};
  display: inline-flex;
  align-items: center;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
  }
`;

export const Column = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 50%;
  }
`;

export const ColumnHeader = styled.p`
  color: ${({ theme }) => theme.colors['neutral-100']};
  background: ${({ theme }) => theme.colors['neutral-20']};
  border: 1px solid ${({ theme }) => theme.colors['neutral-30']};
  border-radius: 4px;
  display: block;
  line-height: 17px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  padding: 7.5px 16px;
`;

export const Table = styled.table`
  border-spacing: 24px 0;
  border-collapse: separate;
  width: 100%;

  tr {
  }

  td {
    width: 50%;
    padding: 5.5px 0;
    vertical-align: top;

    &:first-child {
      text-align: right;
    }
  }
`;

export const TdLabel = styled.td`
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: ${({ theme }) => theme.colors['neutral-80']};
`;

export const TdStatus = styled.td`
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: #655cc1;
`;

export const TdValue = styled.td`
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
`;

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const Tag = styled.p`
  display: inline-block;
  font-weight: 400;
  font-size: 12px;
  line-height: 120%;
  padding: 3px 6px;
  background: ${({ theme }) => theme.colors['neutral-30']};
  border-radius: 4px;
`;
